import I18n from 'I18n';
import CopilotActionButton from 'ai-components-ui-library/components/buttons/CopilotActionButton';
import { REPORTING_INSIGHTS_COPILOT_GENERATION } from 'copilot-toolkit/constants/CopilotInAppActionTypes';
import { getReportDatasetFromReportResolve } from 'reporting-data/report/reportResolveUtils';
import { getIsInsightsShown, getReportDatasetHasNotEnoughDataForAIInsights } from 'reporting-enablement/components/singleReportViewer/fullPage/report-ai-assistant-insights/utils';
import { useContext } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { REPORTING_INSIGHTS_COPILOT_TOOL_GATE } from '../../../constants/gates';
import useCloneTracker from '../../../hooks/useCloneTracker';
import { useGate } from '../../../hooks/useGate';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportingInsightsCopilotButton = ({
  appUsageTracker,
  report,
  reportResolve,
  text = null
}) => {
  var _getReportDatasetFrom;
  const userInfo = useContext(UserInfoContext);
  const tracker = useCloneTracker(appUsageTracker);
  const isUngatedForCopilotAction = useGate(REPORTING_INSIGHTS_COPILOT_TOOL_GATE);
  const datasetNotEnoughData = getReportDatasetHasNotEnoughDataForAIInsights(report, reportResolve);
  if (datasetNotEnoughData || !getIsInsightsShown(report, userInfo) || !reportResolve || !isUngatedForCopilotAction) {
    return null;
  }
  const dashboardCopilotAction = {
    promptText: I18n.text('reporting-enablement.reportCardV2.reportActions.dashboardCopilotButton.promptText'),
    intent: REPORTING_INSIGHTS_COPILOT_GENERATION,
    report: report.toJS(),
    dataset: (_getReportDatasetFrom = getReportDatasetFromReportResolve(report, reportResolve)) === null || _getReportDatasetFrom === void 0 ? void 0 : _getReportDatasetFrom.toJS()
  };
  return /*#__PURE__*/_jsx(CopilotActionButton, {
    usageTracker: tracker,
    size: "xs",
    copilotAction: dashboardCopilotAction,
    tooltip: I18n.text('reporting-enablement.reportCardV2.reportActions.dashboardCopilotButton.tooltip'),
    use: "tertiary",
    shape: "circle"
    // This is necessary to get the border to show up
    ,
    text: text,
    hideIcon: false,
    "aria-label": I18n.text('reporting-enablement.reportCardV2.reportActions.dashboardCopilotButton.tooltip')
  });
};